<template>
  <div id="login">
    <div class="top">
      <i class="iconfont icon-denglu"></i>
    </div>
    <div class="form">
      <input type="text" class="" placeholder="请输入账号" v-model="username">
      <input type="password" class="" placeholder="请输入密码" v-model="password">
      <input style="width: 65%; margin-right: 5%" type="text" class="" placeholder="请输入验证码" v-model="verificationCode">
      <img style="width: 25%; vertical-align: top" title="点击更换" id="refreshCodeId" onclick="$(this).attr('src', '/imageServlet?t=' + Math.random());"
           src="/imageServlet?t=0.8820587174216004">
      <p class="am-fr" style="margin-top: -13px">
        <router-link :to="{name: 'zcgl', params: {nr: 'updPassword'}}">忘记密码?</router-link>
      </p>
      <button style="margin-top: -5px" @click="submit()">登录</button>
      <p>没有账号？<span><router-link :to="{name: 'zcgl', params: {nr: 'register'}}">立即注册</router-link></span></p>
    </div>
    <alert :showModal.sync="showAlert">{{alertMessage}}</alert>
    <div class="am-modal am-modal-confirm" tabindex="-1" id="my-confirm">
      <div class="am-modal-dialog dh-dialog">
        <div class="am-modal-hd">重要提示</div>
        <div class="am-modal-bd">
          <p>在继续浏览本页面前，请您细阅此重要提示，并向下滚动至本页结尾根据您的具体情况进行选择。</p>
          <p>
            在继续浏览本页面前，请您确认您或您所代表的机构是一名"合格投资者"。"合格投资者"指根据中国证券监督管理委员会发布的《私募投资基金监督管理暂行办法》所定义的具备相应风险识别能力和风险承担能力，投资于单只私募基金的金额不低于100万元，且符合下列标准的单位和个人：</p>
          <p>（一）净资产不低于1000万元的单位；</p>
          <p>（二）金融资产不低于300万元或近三年个人年均收入不低于50万元的个人。</p>
          <p>上述金融资产包括银行存款、股票、债券、基金份额、资产管理计划、银行理财产品、信托计划、保险产品、期货权益等。</p>
          <p>下列投资者视为合格投资者：</p>
          <p>（一）社会保障基金、企业年金等养老基金，慈善基金等社会公益基金；</p>
          <p>（二）依法设立并在基金业协会备案的投资计划；</p>
          <p>（三）投资于所管理私募基金的私募基金管理人及其从业人员；</p>
          <p>（四）中国证监会规定的其他投资者。</p>
          <p>您若继续阅览本网页所载资料，将被视为您声明及保证为“合格投资者”，并将遵守中国的有关法例及法规。</p>
          <p>本网站所载的资料仅供参考，并不构成广告或分销、销售要约，或招揽买入任何证券、基金或其他投资工具的邀请或要约。</p>
          <p>
            投资涉及风险，投资者应详细审阅基金的发售文件以获取进一步资料及了解有关投资于私募基金所涉及的风险因素，并寻求适当的专业投资和税务咨询意见。基金份额净值及其收益可升可跌，而过往的基金表现数据并不代表基金未来的表现。 本网站所提供的资料不构成投资建议或税务咨询意见，投资者不应依赖本网站所提供的资料作出投资决策。</p>
          <p>
            东航期货有限责任公司或其关联公司不对本网站所提供资料的准确性、充足性或完整性作出任何保证，也不对于本网站内所提供资料之任何错误或遗漏承担任何法律责任。您在任何情况下均不得复印、复制或再分发本网站资料的全部或其任何部分。</p>
          <p>
            本网站所刊载的所有资料东航期货有限责任公司可予以更改或修订而不必提前通知，东航期货有限责任公司并不承诺定期更新本网页。与本网站所载资料有关的所有版权、专利权、知识产权及其他产权均为东航期货有限责任公司或其关联公司所有。本公司概不向浏览该资料的人士发出、转让或以任何方式转移任何种类的权利。</p>
        </div>
        <div class="am-modal-footer">
          <span class="am-modal-btn" data-am-modal-confirm>我接受</span>
          <span class="am-modal-btn" data-am-modal-cancel>我不接受</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  import alert from '@/components/alert/alert'
  import md5 from 'js-md5'
  import router from '@/router'

  export default {
    name: 'login',
    data () {
      return {
        username: '',
        password: '',
        verificationCode: '',
        alertMessage: '',
        showAlert: false
      }
    },
    mounted: function () {
      this.$emit('update:titlestr', '资产管理登录')
      let mymodal = $('#my-confirm').modal({
        relatedTarget: this,
        onConfirm: function (options) {
        },
        closeViaDimmer: false,
        onCancel: function () {
          router.push({name: 'index'})
        }
      })
      mymodal.modal('open')
      ajax.islogin().then(
        () => {
          if (this.$route.params.nr === 'login') {
            router.replace({name: 'zcgl', params: {nr: 'index'}})
          }
        }
      )
    },
    watch: {
      $route: function () {
        ajax.islogin().then(
          () => {
            if (this.$route.params.nr === 'login') {
              router.replace({name: 'zcgl', params: {nr: 'index'}})
            }
          }
        )
      }
    },
    components: {alert},
    methods: {
      submit: function () {
        if (!this.username && !this.password) {
          this.alertMessage = '用户名密码有空'
          this.showAlert = true
          return
        }
        if (!this.verificationCode) {
          this.alertMessage = '请填写验证码'
          this.showAlert = true
          return
        }
        let senddata = {
          username: this.username,
          password: md5(this.password),
          verificationCode: this.verificationCode
        }
        ajax.login(senddata).then(
          (data) => {
            this.alertMessage = '登录成功'
            this.showAlert = true
            this.$emit('update:username', data.username)
            router.push({name: 'zcgl', params: {nr: 'index'}})
            $('#refreshCodeId').attr('src', '/imageServlet?t=' + Math.random())
          },
          () => {
            $('#refreshCodeId').attr('src', '/imageServlet?t=' + Math.random())
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../../common/stylus/common.styl"
  #my-confirm
    .am-modal-dialog
      width 300px
    .am-modal-hd
      color #992525
      font-size 17px
    .am-modal-bd
      text-align left
      color $font_color1
      font-size 10px
      height 300px
      overflow-x: auto;
</style>



// WEBPACK FOOTER //
// login.vue?22250c0c